import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AffAuthFrame } from "../../components/affiliate/AffAuthFrame";
import { affApi } from "../../lib/affApi";
import { fmtErr } from "../../lib/api";

export function AffiliateForgot() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    try { await affApi.post("/affiliate/forgot-password", { email }); setDone(true); } catch (e2) { setErr(fmtErr(e2)); }
  };
  return (
    <AffAuthFrame title="Reset your password" subtitle="We'll email you a link that works for one hour." testId="aff-forgot-page">
      {done ? (
        <p className="text-sm text-zinc-700" data-testid="aff-forgot-done">If an account exists for <b>{email}</b>, a reset link is on its way. <Link to="/affiliate/login" className="underline">Back to sign in</Link></p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="aff-forgot-form">
          <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="aff-forgot-email" /></div>
          {err && <div className="text-sm text-red-600" data-testid="aff-forgot-error">{err}</div>}
          <Button type="submit" className="w-full bg-ink hover:bg-black" data-testid="aff-forgot-submit">Send reset link</Button>
        </form>
      )}
    </AffAuthFrame>
  );
}

export function AffiliateReset() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    if (pwd !== pwd2) { setErr("Passwords don't match."); return; }
    try {
      await affApi.post("/affiliate/reset-password", { token, new_password: pwd });
      nav("/affiliate/login?reset=1", { replace: true });
    } catch (e2) { setErr(fmtErr(e2)); }
  };
  return (
    <AffAuthFrame title="Choose a new password" testId="aff-reset-page">
      <form onSubmit={submit} className="space-y-4" data-testid="aff-reset-form">
        <div><Label htmlFor="p1">New password</Label><Input id="p1" type="password" minLength={8} value={pwd} onChange={(e) => setPwd(e.target.value)} required data-testid="aff-reset-password" /></div>
        <div><Label htmlFor="p2">Repeat password</Label><Input id="p2" type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} required data-testid="aff-reset-password2" /></div>
        {err && <div className="text-sm text-red-600" data-testid="aff-reset-error">{err}</div>}
        <Button type="submit" className="w-full bg-ink hover:bg-black" data-testid="aff-reset-submit">Set password</Button>
      </form>
    </AffAuthFrame>
  );
}

export default AffiliateForgot;
